
var onQoeTimer = null;
var onBtnTimer = null;

var __cache = {};

function needReport(rate) {
    rate = rate || 0.2;
    return Math.random() <= rate;
}

function send(msg) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://network.console.ksyun.com/qoeman_log', true);
    xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xhr.send(msg);
}

export default {
    performance: function(origin) {
        if (!needReport(1)) {
            return;
        }
        var a = window,
            b = performance,
            t = b.timing,
            arr = _.isFunction(b.getEntriesByType) ? b.getEntriesByType('resource').filter((item) => {
                return "css" !== item.initiatorType && "img" !== item.initiatorType && item.initiatorType !== "xmlhttprequest"
            }) : [],
            reqarr = _.isFunction(b.getEntriesByType) ? b.getEntriesByType('resource').filter((item) => {
                return item.initiatorType == "xmlhttprequest"
            }) : [],
            baseqoe = {
                calculate: function (data) {
                    var timer, info = {};
                    data.forEach(function (item) {
                        let name = item.name.substring(item.name.lastIndexOf('/') + 1)
                        info[name] = {};
                        info[name].duration= item.duration;//内容加载时间
                        info[name].otherTime = item.redirectEnd - item.redirectStart + item.domainLookupEnd - item.domainLookupStart + item.connectEnd - item.connectStart;
                    })
                    return info;
                },
                calcreq: function(data) {
                    var timer, info = {};
                    data.forEach(function (item, idx) {
                        if((item.name).indexOf('Action') == -1) return;
                        let str = item.name.substring(item.name.lastIndexOf('?') + 1),
                            reg = new RegExp("(^|&)Action=([^&]*)(&|$)"),
                            name = str.match(reg)[2];
                        info[name] = {};
                        info[name].duration= item.duration;//内容加载时间
                        info[name].otherTime = item.redirectEnd - item.redirectStart + item.domainLookupEnd - item.domainLookupStart + item.connectEnd - item.connectStart;
                    })
                    return info;
                } 
            },
            qoe = {
                'pageLoadTime': t.loadEventStart - t.navigationStart,
                'dns': t.domainLookupEnd - t.domainLookupStart,
                'ttfb': t.responseStart - t.navigationStart,
                'domReady': t.domComplete - t.responseEnd,
                'tcpConnect': t.connectEnd - t.connectStart,
                'domComplete': t.domComplete - t.navigationStart,
                'docLoad': t.responseEnd - t.navigationStart,
                'prepareAnalysi': t.domLoading - t.responseStart,
                'jsAndCss': baseqoe.calculate(arr),
                'req': baseqoe.calcreq(reqarr),
                'api': 'qoe',
                'origin': origin
            };
        console.log(qoe)
        qoe = encodeURIComponent(JSON.stringify(qoe));
        if (__cache[qoe]) {
            return
        }
        if(_.isFunction(window.performance.clearResourceTimings)) {
            window.performance.clearResourceTimings();
        }
        __cache[qoe] = true;
        if(_.isFunction(window.performance.clearResourceTimings)) {
            window.performance.clearResourceTimings();
        }
        clearTimeout(onQoeTimer); 
        onQoeTimer = setTimeout(function() { 
            send(qoe);
        }, 500);
    },
    EventTracker: function(type, origin) {
        var btnData = {
            type: type,
            origin: origin
        }
        btnData = encodeURIComponent(JSON.stringify(btnData));
        if (__cache[btnData]) {
            return
        }
        __cache[btnData] = true;
        clearTimeout(onBtnTimer); 
        onBtnTimer = setTimeout(function() { 
            send(btnData);
        }, 500);
    }
};
